import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import PageHeader from '../../components/admin/PageHeader'

/**
 * @param {{ title: string, description?: string, children?: React.ReactNode }} props
 */
export default function PlaceholderPage({ title, description, children }) {
  return (
    <Box>
      <PageHeader title={title} description={description} />
      <Paper variant="outlined" sx={{ p: 2.5 }}>
        {children || (
          <Typography variant="body2" color="text.secondary">
            UI scaffold — connect to your Express admin API when the endpoint is ready.
          </Typography>
        )}
      </Paper>
    </Box>
  )
}
